import { Dialog } from '@headlessui/react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: React.ReactNode;
  children?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClassName?: string;
  cancelButtonClassName?: string;
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClassName = 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500',
  cancelButtonClassName = 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-gray-500',
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <div className="fixed inset-0 bg-black/30 z-[100]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 z-[100]">
        <Dialog.Panel className="mx-auto max-w-sm rounded-lg bg-white p-6">
          <Dialog.Title className="text-lg font-medium leading-6 text-gray-900">
            {title}
          </Dialog.Title>
          <div className="mt-2">
            {message && (
              <div className="text-sm text-gray-500">
                {message}
              </div>
            )}
            {children}
          </div>

          <div className="mt-4 flex justify-end space-x-2">
            <button
              type="button"
              className={`inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${cancelButtonClassName}`}
              onClick={onClose}
            >
              {cancelText}
            </button>
            <button
              type="button"
              className={`inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${confirmButtonClassName}`}
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {confirmText}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
